<!-- Copyright 2019, Nathan Lecompte -->

<template>
    <a class="v-res-item" :href="item.url" rel="noopener noreferrer" :title="item.title">
        <img v-if="item.img" class="v-res-img" :src="item.img" :alt="item.title"/>
        <svg v-if="!item.img" class="v-res-img" viewBox="0 0 640 360" xmlns="http://www.w3.org/2000/svg"><path d="m341.5 148.5c-8.2-11.4-16.5-21.6-21-26.9-4.5 5.4-12.8 15.5-21 26.9-7 9.8-12.6 18.6-16.6 26.2-5.9 11.3-7.2 17.7-7.2 21.1 0 22.4 20.1 40.6 44.8 40.6h1.7c23.9-.8 43.1-18.7 43.1-40.5 0-3.4-1.2-9.8-7.2-21.1-3.9-7.7-9.5-16.5-16.6-26.3z"/><path d="m0 0v360h640v-360zm320.5 295c-63.5 0-115-51.5-115-115s51.5-115 115-115 115 51.5 115 115-51.5 115-115 115z"/></svg>
        <div class="v-res-info">
            <h2>{{ item.title }}</h2>
            <img :src="item.icon" alt="favicon"/>
            <p>{{ item.engine }}</p>
        </div>
    </a>
</template>

<script>
export default {
    props: {
        item: {
            type: Object,
            required: true
        }
	}
}
</script>

<style>
/* Video search results */
.v-res {
	text-align: center
}

/* Video result */
.v-res-item {
	display: inline-block;
	padding: 4px;
	border-radius: 2px;
	font-weight: 600;
	color: rgba(var(--primaryColor), var(--primaryOpacity));
	-webkit-tap-highlight-color: transparent;
	transition: calc(var(--animationSpeed)/2) ease
}
.v-res-item:hover,
.v-res-item:focus {
	color: rgb(var(--primaryColor));
	background: rgba(var(--primaryColor), .025)
}
.v-res-item:active {
	transform: scale(.98);
	background: rgba(var(--primaryColor), .05)
}

/* Video result > Image */
.v-res-img {
	max-height: 141px;
	max-width: 250px;
	min-width: 250px;
	width: 100%;
	border-radius: 2px;
	z-index: 2
}
.v-res-item svg {
	fill: rgba(var(--primaryColor), .125)
}

/* Video result > Info */
.v-res-info {
	display: block;
	position: relative;
	text-align: left;
	height: 80px;
	margin-top: -7px
}
.v-res-info h2, .v-res-info p, .v-res-info img {
	position: absolute;
	margin: 0;
	overflow: hidden;
	white-space: nowrap;
	text-overflow: ellipsis
}
.v-res-info h2 {
	top: 14px;
	left: 10px;
	right: 10px;
	font-size: 1.05em;
	font-weight: 600;
	color: rgb(var(--accentColor))
}
.v-res-item:visited h2 {
	color: var(--linkVisitedColor)
}
.v-res-info p {
	top: 50px;
	right: 10px;
	left: 45px;
	font-size: .9em;
	font-weight: 400;
	text-align: right
}
.v-res-info img {
	min-width: 16px;
	width: 16px;
	height: 16px;
	top: 52px;
	left: 10px;
	border-radius: 0
}

/* Media queries (mobile/responsive) */
@media (max-width: 600px) {
	.v-res-item {
		display: block;
		padding: 20px 20px 4px
	}
	.v-res-img {
		max-width: 100%;
		max-height: 100%
	}
}
</style>